import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/system';
import { OptionType, DealPostType } from '@types';
import DealSortSelect from '@pages/Pages/components/DealSortSelect';
import FilterCategorySelect from '@pages/Pages/components/FilterCategorySelect';
import FilterByPromotion from '@pages/Pages/components/FilterByPromotion';
import FilterByCoupon from '@pages/Pages/components/FilterByCoupon';
import FilterByBrand from '@pages/Pages/components/FilterByBrand';
import FilterBySize from '@pages/Pages/components/FilterBySize';

const StickyFilters = ({
  pageDealData,
  sortOrder,
  setSortOrder,
  categoryFilters,
  handleChangeCategoryFilter,
  renderSearch,
  isPromotions,
  setPromotionFilter,
  promotionFilter,
  deals,
  showBrandFilter,
  setBrandFilter,
  brandFilter,
  isDiapers,
  setSizeFilter,
  sizeFilter,
  scrollToTop,
  setLimit,
  categories,
  showCouponFilter,
  setCouponFilter,
  couponFilter
}: {
  pageDealData: any;
  sortOrder: string;
  setSortOrder: (value: string) => void;
  showCouponFilter: boolean;
  categoryFilters: OptionType[];
  handleChangeCategoryFilter: (cats: OptionType[]) => void;
  renderSearch: () => JSX.Element;
  isPromotions: boolean;
  setPromotionFilter: (filter: string) => void;
  promotionFilter: string;
  setCouponFilter: (filter: string) => void;
  couponFilter: string;
  deals: DealPostType[];
  showBrandFilter: boolean;
  setBrandFilter: (brand: string) => void;
  brandFilter: string;
  isDiapers: boolean;
  setSizeFilter: (size: string) => void;
  sizeFilter: string;
  scrollToTop: () => void;
  setLimit: (limit: number) => void;
  categories: [string, number][];
}) => {
  const theme = useTheme();
  const hasSortAndFilter =
    pageDealData?.pageDeal?.showSort &&
    pageDealData?.pageDeal?.showCategoryFilter;

  const allFilterStyles = {
    margin: '12px 12px 6px 12px'
  };

  const namedFilterStyles = {
    margin: '14px 12px 6px 12px'
  };

  const sortAndFilterStylesLeft = hasSortAndFilter
    ? {
        width: {
          xs: 'initial',
          sm: '50%'
        },
        display: {
          xs: 'block',
          sm: 'flex'
        },
        margin: {
          xs: '12px 12px 6px 12px',
          sm: '12px 0px 6px 12px'
        }
      }
    : {};

  const sortAndFilterStylesRight = hasSortAndFilter
    ? {
        width: {
          xs: 'initial',
          sm: '50%'
        },
        display: {
          xs: 'block',
          sm: 'flex'
        },
        margin: {
          xs: '14px 12px 6px 12px',
          sm: '12px 12px 6px 12px'
        }
      }
    : {};

  const searchAndFilterBoxStyles = hasSortAndFilter
    ? {
        display: {
          xs: 'block',
          sm: 'flex'
        }
      }
    : {};

  const searchMargin = {
    margin: {
      xs: '12px 12px 6px 12px',
      sm: '6px 12px 6px 12px'
    }
  };

  return (
    <Box
      sx={{
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        position: 'static',
        top: 0,
        borderBottom: '1px solid #CCC',
        zIndex: 2,
        marginLeft: '-16px',
        marginRight: '-16px',
        backgroundColor: theme.palette.background.paper
      }}
    >
      <Box paddingBottom="6px">
        <Box sx={searchAndFilterBoxStyles}>
          {pageDealData?.pageDeal?.showSort && (
            <Box
              sx={{
                ...{
                  margin: '12px'
                },
                ...sortAndFilterStylesLeft
              }}
            >
              <DealSortSelect
                value={sortOrder}
                onChange={setSortOrder}
                showPopular
              />
            </Box>
          )}
          {pageDealData?.pageDeal?.showCategoryFilter && (
            <Box sx={{ ...allFilterStyles, ...sortAndFilterStylesRight }}>
              <FilterCategorySelect
                categoryFilters={categoryFilters}
                onChange={handleChangeCategoryFilter}
                categories={categories}
              />
            </Box>
          )}
        </Box>
        {pageDealData?.pageDeal?.showSearch && (
          <Box sx={{ ...allFilterStyles, ...searchMargin }}>
            {renderSearch()}
          </Box>
        )}
        {isPromotions && (
          // <Grid item xs={12} sx={{ marginBottom: '12px', paddingTop: '12px' }}>
          <Box sx={{ ...allFilterStyles, ...namedFilterStyles }}>
            <FilterByPromotion
              setPromotionFilter={(filter: string) => {
                setLimit(100);
                setPromotionFilter(filter);
              }}
              promotionFilter={promotionFilter}
              deals={deals}
            />
          </Box>
        )}
        {showCouponFilter && (
          <Box sx={{ ...allFilterStyles, ...namedFilterStyles }}>
            <FilterByCoupon
              setCouponFilter={(filter: string) => {
                setLimit(100);
                setCouponFilter(filter);
              }}
              couponFilter={couponFilter}
              deals={deals}
            />
          </Box>
        )}
        {showBrandFilter && (
          <Box sx={{ ...allFilterStyles, ...namedFilterStyles }}>
            <FilterByBrand
              setBrandFilter={(brand: string) => {
                setBrandFilter(brand);
                setLimit(100);
                scrollToTop();
              }}
              brandFilter={brandFilter}
              deals={deals}
            />
          </Box>
        )}
        {isDiapers && (
          <Box sx={{ ...allFilterStyles, ...namedFilterStyles }}>
            <FilterBySize
              deals={deals}
              sizeFilter={sizeFilter}
              setSizeFilter={setSizeFilter}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default StickyFilters;
